// <copyright file="loaderConfigApp.tsx" company="Top365">
// Copyright (c) Top365. All rights reserved.
// </copyright>

import * as React from "react";
import { Divider, Text, Flex, FlexItem, Grid, List, Skeleton } from "@fluentui/react-northstar";
const _ = require('lodash');
import "./loader.scss";
import '../../components/settings/settings.scss';

/** Component for displaying loading component. */
const LoaderConfigApp = (): JSX.Element => {
    return (
        <div className="taskModule">
            <Skeleton animation="pulse">
                <div className="formContainer">
                    <div className="formContentContainer" >
                        <div className="inputField">
                            <Flex gap="gap.small" column>
                                <Skeleton.Line width="150px" height="18px" className="label-field" />
                                <Skeleton.Line height="36px" />
                            </Flex>                            
                        </div>
                        
                        <div className="inputField">                            
                            <Flex gap="gap.small" column>
                                <Skeleton.Line width="100px" height="18px" className="label-field" />
                                <Skeleton.Line height="36px" />
                            </Flex>
                        </div> 

                        <div className="inputField"> 
                            <Flex space="between" gap="gap.small">
                                <FlexItem size="size.half">
                                    <div>
                                        <Skeleton.Line width="100px" height="18px" className="label-field" />
                                        <Skeleton.Line height="30px" />
                                    </div>
                                </FlexItem>

                                <FlexItem size="size.half">
                                    <div>
                                        <Skeleton.Line width="100px" height="18px" className="label-field" />
                                        <Skeleton.Line height="30px" />
                                    </div>
                                </FlexItem>
                            </Flex>
                        </div>

                        <div className="inputField">
                            <Flex gap="gap.small" column>
                                <Skeleton.Line width="100px" height="18px" className="label-field" />
                                <Skeleton.Line height="30px" />
                            </Flex>
                        </div>

                        <div className="inputField"> 
                            <Flex space="between" gap="gap.small">
                                <FlexItem size="size.half">
                                    <div>
                                        <Skeleton.Line width="100px" height="18px" className="label-field" />
                                        <Skeleton.Line height="36px" />
                                    </div>
                                </FlexItem>

                                <FlexItem size="size.half">
                                    <div>
                                        <div style={{ height: "38px" }} ></div>
                                        <Skeleton.Line height="36px" />
                                    </div>
                                </FlexItem>
                            </Flex> 
                        </div>

                    </div>
                </div>

                <div className="footerContainer">
                    <div className="buttonContainer">
                        <Flex gap="gap.small">
                            <Skeleton.Button />
                            <Skeleton.Button />
                        </Flex>
                    </div>
                </div>
            </Skeleton>
        </div>
    );
};

export default LoaderConfigApp;